const model = {
    orderOut: [],
    loading: false,
    error: null,
    status: null,
};

export default model;